import React from 'react';
import { AlertItem } from '../../Services/serviceURL';
import SummaryAlertListItem from './SummaryAlertListItem';

type Props = {
  assetName: string;
  alerts: AlertItem[];
  onClose: () => void;
};

const SummaryAlertsModal: React.FC<Props> = ({ assetName, alerts, onClose }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content-alert alerts-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h3>Alerts for {assetName}</h3>
        <button className="modal-close-btn" onClick={onClose} type="button">
          ×
        </button>
      </div>
      <div className="modal-body">
        <div className="alerts-list alerts-list-scrollable">
          {alerts.length > 0 ? (
            alerts.map((alert, index) => <SummaryAlertListItem key={index} alert={alert} />)
          ) : (
            <div className="no-alerts-message">
              <span className="alert-icon">ℹ️</span>
              <p>No alerts found for this asset.</p>
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn-secondary" onClick={onClose} type="button">
          Close
        </button>
      </div>
    </div>
  </div>
);

export default SummaryAlertsModal;
